import { createSlice } from '@reduxjs/toolkit';

// Slice
export const internalSlice = createSlice({
  initialState: {
    internal: {
      authenticityToken: undefined,
      accountId: undefined,
      assetId: undefined,
      libraryId: undefined,
      user: undefined,
    },
  },
  name: 'internal',
  reducers: {
    setInternal: (state, action) => {
      state.internal = action.payload;
    },
  },
});

// Reducer
export const internalReducer = internalSlice.reducer;

// Actions
export const { setInternal } = internalSlice.actions;

// Selectors
export const selectInternalResult = (state) => state.internalReducer.internal;
